import * as React from 'react';
import { useState } from 'react';

import { cn } from '@utils/cn';

import { Icon } from '@ui-component-library/components/Icon';

import {
  checkboxIconClasses,
  customCheckboxClasses,
  hiddenInputClasses,
  labelClasses
} from './Checkbox.styles';
import type { CheckboxProps } from './Checkbox.types';

export const Checkbox = ({
  onClick,
  name,
  children,
  className,
  checked: defaultChecked = false,
  disabled = false
}: CheckboxProps) => {
  const [checked, setChecked] = useState(defaultChecked);

  if (!onClick) {
    console.warn('Checkbox onClick is required');
    return null;
  }

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newChecked = e.target.checked;
    setChecked(newChecked);
    onClick(newChecked, name);
  };

  return (
    <label htmlFor={name} className={cn(labelClasses({ disabled }), className)}>
      {!disabled && (
        <input
          id={name}
          type="checkbox"
          className={hiddenInputClasses()}
          onChange={handleChange}
          checked={checked}
          name={name}
        />
      )}

      <div className={cn(customCheckboxClasses({ checked }))}>
        <Icon name="CheckSimple" size="small" className={cn(checkboxIconClasses({ checked }))} />
      </div>

      {children}
    </label>
  );
};
